module.exports = __webpack_public_path__ + "static/media/nft-3.9007a316.png";